import * as React from "react";
import type { SVGProps } from "react";

const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={34}
    viewBox="0 0 48 34"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        stroke="#E6E7E8"
        strokeWidth={0.72}
        d="M45.355.36a1.804 1.804 0 0 1 1.805 1.8v28.8a1.802 1.802 0 0 1-1.805 1.8H2.165a1.804 1.804 0 0 1-1.805-1.8V2.16A1.802 1.802 0 0 1 2.165.36z"
      />
      <g fill="#0742A6">
        <path d="M21.616 21.416h-2.548l1.594-9.599h2.548zm9.239-9.365a6.4 6.4 0 0 0-2.286-.408c-2.517 0-4.29 1.307-4.3 3.175-.02 1.379 1.269 2.145 2.234 2.604.986.47 1.32.777 1.32 1.196-.01.643-.796.939-1.53.939-1.017 0-1.562-.153-2.39-.51l-.336-.154-.357 2.155c.598.265 1.699.5 2.842.51 2.674 0 4.415-1.286 4.436-3.277.01-1.093-.67-1.93-2.14-2.615-.89-.439-1.437-.735-1.437-1.184.01-.409.462-.827 1.468-.827a4.4 4.4 0 0 1 1.899.367l.23.102z" />
        <path
          fillRule="nonzero"
          d="M34.242 18.015c.21-.551 1.018-2.686 1.018-2.686-.01.02.21-.561.335-.919l.178.827s.483 2.298.588 2.778zm3.146-6.198h-1.971c-.608 0-1.07.173-1.332.796l-3.786 8.803h2.674l.535-1.44h3.272c.073.337.304 1.44.304 1.44h2.36z"
        />
        <path d="m16.939 11.817-2.496 6.545-.273-1.327c-.46-1.532-1.908-3.196-3.523-4.025l2.286 8.394h2.695l4.006-9.587z" />
        <path d="M12.125 11.817h-4.1l-.042.193c3.199.796 5.317 2.716 6.187 5.024l-.89-4.411c-.148-.613-.6-.786-1.155-.806" />
      </g>
    </g>
  </svg>
);
export default SvgVisa;
